import PageRoot from "../../../components/common/form/PageRoot";
import Canonical from "../../../components/common/layout/Canonical";
import RecruitmentHeader from "../../../components/common/layout/RecruitmentHeader";
import SubVacanciesList from "../../../components/corporate/recruitment/SubVacanciesList";
import { useState } from "react";

const DeptJobs = () => {
    const [data, setData] = useState<any>(null)

    return (
        <>
            <Canonical />
            <div className="w-full h-full dark:bg-bgDarkDull bg-white">
                <div className="relative z-[1]">
                    <RecruitmentHeader />
                    <PageRoot page="All Jobs" subPage={data?.department_details?.name} />
                </div>

                <div id="home">
                    <SubVacanciesList setData={setData} loading={false} />
                </div>
            </div>
        </>
    );
};

export default DeptJobs;